/** Espelha public.tipo_formato_envio (db_compras) e `TipoFormatoEnvioEnum` da API Compras: formato de envio ao fornecedor. */
export enum TipoFormatoEnvioEnum {
  LinkPortal = 1,
  PlanilhaExcel = 2,
  PdfPreencher = 3,
}
